<header class="container-fluid top-0 left-0 bg-body shadow-sm">
  <div class="row align-items-center h-100">
    <div class="col-auto d-flex align-items-center justify-content-center gap-3" routerLink="/">
      @if(!clinic) {
      <img src="icons/logo.svg" alt="logo" class="logo d-none d-md-block" />
      }@else {
      <img
        class="logo d-none d-md-block"
        [src]="clinic.awsBucketLogoKey | signedUrl : path | async"
        alt="Clinic logo"
      />
      }
    </div>

    <div class="col d-flex justify-content-end align-items-center gap-3">
      @if(fullName&&clinic&&patientId) {
      <button type="button" (click)="openPlanner()" class="btn btn-outline-primary d-none d-md-block">
        {{ 'planner.title' | transloco }}
      </button>
      <button type="button" (click)="goToVideoconsultation()" class="btn btn-outline-primary d-none d-md-block">
        {{ 'meeting.title' | transloco }}
      </button>
      <!-- <button type="button" (click)="goToMediapipe()" class="btn btn-outline-primary">
        {{ 'mediapipe' | transloco }}
      </button> -->
      <button type="button" (click)="goToTelediagnosis()" class="btn btn-outline-primary d-none d-md-block">
        {{ 'telediagnosis' | transloco }}
      </button>

      } @if(!clinic) {<app-header-basket></app-header-basket>} @if(fullName){
      <div class="d-flex align-items-center gap-2 cursor text-primary" routerLink="staff-info">
        <i class="bi bi-person-circle fs-2"></i>
        <span class="">{{ user | fullName }}</span>
      </div>
      <i class="bi bi-box-arrow-in-right cursor text-secondary fs-2" (click)="logout()"></i>
      }
    </div>
  </div>
</header>
@if(fullName&&clinic&&patientId){
<app-planner-modal></app-planner-modal>
}
